import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CaseProcedureConfigurationModel} from '../../../../models/caseProcedures/case-procedure-configuration.model';

@Component({
  selector: 'app-case-create-child-procedures-dialog',
  templateUrl: './case-create-child-procedures-dialog.component.html',
  styleUrls: ['./case-create-child-procedures-dialog.component.scss']
})
export class CaseCreateChildProceduresDialogComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<CaseCreateChildProceduresDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: CaseProcedureConfigurationModel[]) {
    //
  }

  ngOnInit(): void {
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  clickProcedureSelected(p: CaseProcedureConfigurationModel) {
    this.dialogRef.close(p);
  }
}
